const FACEBOOK_APP_ID = import.meta.env.VITE_FACEBOOK_APP_ID

declare global {
  interface Window {
    fbAsyncInit: () => void
    FB: {
      init: (params: { appId: string; cookie: boolean; xfbml: boolean; version: string }) => void
      login: (cb: (response: FacebookLoginResponse) => void, opts?: { scope: string }) => void
      getLoginStatus: (cb: (response: FacebookLoginResponse) => void) => void
    }
  }
}

interface FacebookLoginResponse {
  status: 'connected' | 'not_authorized' | 'unknown'
  authResponse?: {
    accessToken: string
    userID: string
  }
}

let sdkLoaded = false

function loadSDK(): Promise<void> {
  if (sdkLoaded) return Promise.resolve()
  return new Promise((resolve) => {
    window.fbAsyncInit = () => {
      window.FB.init({
        appId: FACEBOOK_APP_ID,
        cookie: true,
        xfbml: false,
        version: 'v19.0',
      })
      sdkLoaded = true
      resolve()
    }
    const script = document.createElement('script')
    script.src = 'https://connect.facebook.net/en_US/sdk.js'
    script.async = true
    script.defer = true
    document.head.appendChild(script)
  })
}

export async function facebookLogin(): Promise<string> {
  await loadSDK()
  return new Promise((resolve, reject) => {
    window.FB.login(
      (response) => {
        if (response.status === 'connected' && response.authResponse) {
          resolve(response.authResponse.accessToken)
        } else {
          reject(new Error('Facebook нэвтрэлт цуцлагдсан'))
        }
      },
      { scope: 'email,public_profile' },
    )
  })
}
